<template>
  <div>
    <Nav num="1"></Nav>
    <div class="classify">
      <div class="head-menu main">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>找靠谱产品</el-breadcrumb-item>
            <el-breadcrumb-item>
              <el-dropdown @command="typeChange" size="small" placement="bottom">
                <span>{{ type === '1' ? '产品严选' : '产品普选' }}</span>
                <el-dropdown-menu>
                  <el-dropdown-item v-if="type==='1'" command="0">产品普选</el-dropdown-item>
                  <el-dropdown-item v-else command="1">产品严选</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </el-breadcrumb-item>
            <el-breadcrumb-item v-show="oneClassifyName">{{ oneClassifyName }}</el-breadcrumb-item>
            <el-breadcrumb-item v-show="twoClassifyName">{{ twoClassifyName }}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      <div class="classify-head main">
        <!-- 标题 -->
        <div class="head-title">
          <h1 class="title">{{ twoClassifyName || (type === '1' ? '产品严选' : '产品普选') }}</h1>
          <span class="reset" @click="reset"><i class="el-icon-refresh-left"></i>重置</span>
        </div>

        <!-- 分类列表 -->
        <Menus :type="type" ref="menus" @menuChange="menuChange"/>

      </div>
      <div class="main" v-if="productCategoryId">
        <div class="tabs">
          <div
              class="tab-item"
              v-for="(item,index) in tabList"
              :class="tabId === item.id ? 'active':null"
              @click="tabId = item.id"
          >{{ item.name }}
          </div>
        </div>
      </div>
      <div class="main classify-body" v-if="productCategoryId">
        <div class="left" v-show="tabId===0">
          <!--简介-->
          <introduction :text="twoClassifyData" ref="introduction"/>
          <!--厂商/排序-->
          <manufacturers
              :type="type"
              :productCategoryId="productCategoryId"
              @search="search"
              ref="manufacturers"
          />
          <!--咨询滚动消息-->
          <vue-seamless-scroll
              :data="askNews"
              :class-option="{
                step: 0.8,
                direction: 2,
                limitMoveNum:2,
            }"
              class="warp"
          >
            <ul class="newsBox">
              <li class="news" v-for="(item,index) in askNews" :key="index">
                <span>{{ item.contacts }}</span>
                <span class="time" style="color:#EB5412">咨询了</span>
                <a style="color:#d7b084" :href="item.url.replace('#','')" :title="item.title">
                  {{ item.title.slice(item.title.lastIndexOf("|") + 1) }}
                </a>
                <span class="time">(IT产品)</span>
              </li>
            </ul>
          </vue-seamless-scroll>
          <!--产品列表-->
          <list :listData="filterData" :total="listData.recordCount" :pageCurrent="pageCurrent"
                v-loading="listLoading" @currenChange="currenChange" :type="type"/>
        </div>
        <div class="left" v-show="tabId===1">
          <article-list :list="articleData" v-if="articleData.length"/>
          <div class="empty" v-else>
            <el-empty description="暂无数据"></el-empty>
          </div>
        </div>
        <div class="right">
          <Circles :productCategoryId="productCategoryId" :productMainTypeId="productMainTypeId"/>
          <Expert :productCategoryId="productCategoryId"/>
          <Comments :productMainTypeId="productMainTypeId"/>
        </div>
      </div>
      <div class="main" v-else>
        <!--产品列表-->
        <list :listData="filterData" :total="listData.recordCount" :pageCurrent="pageCurrent"
              @currenChange="currenChange" :type="type"/>
      </div>

    </div>
    <!-- 红包抽奖 -->
    <lottery :visible="lotteryVisible" @start="onStartLottery"></lottery>
    <div class="modal fade" id="lotteryDialog" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"
         style="margin-top: 40vh">
      <div class="modal-dialog" role="document" style="width: 300px">
        <div class="modal-content">
          <div class="modal-header" style="display: flex;justify-content: center;align-items: center">
            <div style="color: red">红包抽奖</div>
            <button type="button" class="close login-close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div>请完成具体IT产品.行业软件.IT公司点评后提交，单单有奖；</div>
          </div>
        </div>
      </div>
    </div>
    <VueFoot/>
  </div>
</template>
<script>
import Nav from '../qdw/head.vue'
import Menus from "./components/menus.vue";
import VueFoot from "../qdw/foot.vue";
import Introduction from "./components/introduction.vue";
import Manufacturers from "./components/manufacturers.vue";
import {getAction, httpAction, postAction} from "../../utils/api/manages";
import vueSeamlessScroll from "vue-seamless-scroll"
import List from "./components/list.vue";
import Circles from "./components/circles.vue";
import Expert from "./components/expert.vue";
import Comments from "./components/comments.vue";
import Lottery from "@/components/lottery/lottery.vue";
import ArticleList from "@/views/productList/components/articleList.vue";

export default {
  components: {
    ArticleList,
    Lottery,
    Comments,
    Expert,
    Circles,
    List,
    Manufacturers,
    Introduction,
    VueFoot,
    Menus,
    Nav,
    vueSeamlessScroll
  },
  data() {
    return {
      type: "1", // 类型
      // 一级导航名称
      oneClassifyName: null,
      // 二级导航名称
      twoClassifyName: null,
      productCategoryId: null,
      productMainTypeId: null,
      tabList: [
        {id: 0, name: '概述&厂商'},
        {id: 1, name: '文章'},
      ],
      tabId: 0,
      twoClassifyData: {},
      // 咨询滚动消息
      askNews: [],
      // 产品列表
      listData: {
        data: []
      },
      filterData: [],
      // 默认第几页
      pageCurrent: 1,
      listLoading: false,
      lotteryVisible: false,
      // 文章数据
      articleData: [],
    }
  },
  created() {
    const {type, productCategoryId, productMainTypeId} = this.$route.query
    this.type = type
    this.productCategoryId = productCategoryId
    this.productMainTypeId = productMainTypeId
    this.getAskNews()
    this.getList()
    if (productCategoryId) {
      this.getProductArticle()
    }
  },
  mounted() {
    setTimeout(() => {
      this.lotteryVisible = true
    }, 2000)
  },
  watch: {
    combinedChange: {
      handler(val) {
        this.pageCurrent = 1
        this.tabId = 0
        this.getList()
        if (this.$refs.manufacturers) {
          this.$refs.manufacturers.reset()
        }
        if (this.productCategoryId) {
          this.getProductArticle()
        }
      },
      deep: true,
      immediate: false
    }
  },
  computed: {
    // 计算属性监听两个值变化
    combinedChange() {
      return [this.productCategoryId, this.productMainTypeId, this.type];
    }
  },
  methods: {
    typeChange(e) {
      this.$router.replace({path: `product-classify?type=${e}`})
      this.productCategoryId = null
      this.productMainTypeId = null
      this.type = e
    },
    reset() {
      this.$refs.menus.reset()
    },
    menuChange(data) {
      let {
        twoClassifyName,
        oneClassifyName,
        productCategoryId,
        productMainTypeId,
        twoClassifyData
      } = data
      this.twoClassifyName = twoClassifyName
      this.oneClassifyName = oneClassifyName
      this.productCategoryId = productCategoryId
      this.productMainTypeId = productMainTypeId
      this.twoClassifyData = twoClassifyData || {}
      this.$nextTick(() => {
        if (!this.$refs.introduction) return
        this.$refs.introduction.isLoading = false
      })
    },
    // 搜索
    search(item) {
      const {orderField, orderType, filterName} = item
      let data = JSON.parse(JSON.stringify(this.listData.data))
      if (filterName) {
        data = this.listData.data.filter(item => item.tagName === filterName)
      }
      if (orderField && orderType === 'order') {
        data.sort((a, b) => a[orderField] - b[orderField])
      } else if (orderField && orderType === 'desc') {
        data.sort((a, b) => b[orderField] - a[orderField])
      }
      this.filterData = data
    },
    // 获取滚动咨询消息
    getAskNews() {
      getAction('/userconsulting/detail/list?url=product')
          .then(res => {
            this.askNews = res.rows
          })
    },
    // 获取产品列表
    getList() {
      this.listLoading = true
      let searchData = {
        // productMainTypeId: this.productMainTypeId,
        categoryId: this.productCategoryId,
        productType: this.type === '0' ? 2 : null,
        limit: 40,
        page: this.pageCurrent,
        productMainTypeId: null,
        deliveryMode: null,
      }
      if (this.productMainTypeId > 3) {
        searchData.productMainTypeId = this.productMainTypeId
      } else {
        searchData.deliveryMode = this.productMainTypeId
      }
      httpAction({
        url: '/product/list',
        method: 'post',
        data: searchData,
        noToken: true,
      }).then(res => {
        this.listData = res
        // this.filterData = res.data
        this.onceLoad(res.data)
      }).finally(() => {
        this.listLoading = false
      })
    },
    // 获取文章内容
    getProductArticle() {
      httpAction({
        url: Discuz_url + '/plugin.php?id=qidaoData:api&m=getCateCms',
        method: 'get',
        params: {
          cate1: 'product2',
          cate3: this.productCategoryId,
          cate2: this.productMainTypeId,
        },
        // 不携带token
        noToken: true,
      }).then(res => {
        this.articleData = res.data || []
      })
    },
    // 翻页
    currenChange(page) {
      this.pageCurrent = page
      this.getList()
    },
    onStartLottery() {
      const username = localStorage.getItem("username")
      if (!username) {
        $("#loginModal").modal("show")
      } else {
        $("#lotteryDialog").modal("show")
      }
      this.lotteryVisible = false
    },
    // 分帧渲染
    onceLoad(data) {
      this.filterData = []
      let index = 0;
      const batchSize = 6; // 每次渲染的数量，可以根据需要调整
      const renderBatch = () => {
        // 每次渲染一部分数据
        const batch = data.slice(index, index + batchSize);
        this.filterData.push(...batch);
        index += batchSize;

        // 如果还有未渲染的数据，继续调用 requestAnimationFrame
        if (index < data.length) {
          requestAnimationFrame(renderBatch);
        }
      }

      // 开始渲染第一批数据
      requestAnimationFrame(renderBatch)
    }
  }
}

</script>

<style scoped lang="scss">
.main {
  max-width: 1196px;
  margin: 0 auto 20px;

  &:last-child {
    margin-bottom: 0;
  }
}


.classify {
  padding-top: 144px;
  background: #f4f4f4;
  .head-menu {
      margin-bottom: 0px !important;
      padding-top: 0;
      background: #ffffff;
      height: 50px;
      display: flex;
      align-items: center;
      padding-left: 20px;
      border-radius: 6px 6px 0 0;
      border-bottom: 1px solid #DCDFE6;
    }
  .classify-head {
    background-color: #ffffff;
    padding: 20px;
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

    

    .head-title {
      display: flex;
      padding: 0px 0 20px 0;
      justify-content: space-between;
      align-items: center;

      .title {
        font-size: 20px;
        font-weight: 700;
      }

      .reset {
        cursor: pointer;

        &:hover {
          color: #eb5412;
        }
      }
    }

    .head-list {

    }
  }

  .tabs {
    display: flex;
    gap: 16px;
    line-height: 40px;
    margin: 10px 20px;
    padding-bottom: 4px;

    .tab-item {
      position: relative;
      cursor: pointer;
      font-size: 16px;

      &:after {
        content: '';
        position: absolute;
        top: 100%;
        display: none;
        width: 100%;
        height: 4px;
        background-color: var(--swiper-theme-color);
        border-radius: 4px;
      }

      &:hover {
        color: var(--swiper-theme-color);
      }

      &.active {
        font-weight: 700;

        &:after {
          display: block;
        }

        color: var(--swiper-theme-color);
      }
    }
  }

  .classify-body {
    display: flex;
    gap: 16px;
    flex: 1;

    .left {
      flex: 1;
      overflow: hidden visible;

      .warp {
        overflow: hidden;
        border-radius: 5px;
        font-weight: 500;
        background: #2c3d62;
        height: 30px;
        width: 100%;
        margin-bottom: 20px;
        padding: 5px;
        box-sizing: border-box;

        .newsBox {
          display: flex;
          width: 100%;
          overflow: hidden;
          gap: 20px;
          flex-shrink: 0;
          margin-bottom: 20px;

          .news {
            min-width: 150px;
            color: rgb(235, 216, 201);


            .time {
              //font-size: 12px;
              //color: #232f3e;
              //opacity: 0.5;
              color: rgb(215, 176, 132);
            }
          }
        }
      }
    }

    .right {
      width: 300px;
      display: flex;
      flex-direction: column;
      gap: 20px;
    }
  }

  .empty {
    width: 100%;
    background: #ffffff;
    border-radius: 6px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  }
}


</style>